export default {
  userTasks: [],
  spinnerVisible: false,
  isMobile: false,
  isTablet: false,
  isDesktop: false,
  isError: false,
  colors: {},
  campaign: {
    css_settings: {},
    accept_languages: ["it"]
  },
  user: {
    profile: {
      first_name: "",
      last_name: ""
    },
    points: 0
  },
  surveyProfile: {},
  locale: null
};
